export class SourceTypeConstant {
    public static TITAN_AS400 = 'TITAN_AS400';
    public static AS400 = 'AS400';
    public static TITAN = 'TITAN';
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/source-type.contants.ts